import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";

// 人才資源頁面
export const Lecturer = () => {
  return (
    <div className="mb-16">
      <div className="">
        <Disclosure>
          <div className="flex items-center staticBanner bg-[#fdfbc9] relative">
            <div className="staticBannerContent">
              <img
                src="/images/resourceBanner.png"
                alt="banner"
                className="staticBannerImg"
              />
              <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-[45%] max-h-full">
                <h2 className=" font-black text-primaryDark leading-tight text-center">人才資源</h2>
                {/* <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              透過我們的平台，學生只需一個帳號即可使用天下雜誌群知識庫、均一教育平台等多種數位資源，享受無縫學習體驗，拓展知識，培養技能，為未來成長打下堅實基礎。
            </p> */}
              </div>

            </div>
          </div>

          <div className="staticSection !pb-0">
            <div className="sectionContent">
              <div className="border-2 border-headline relative text-base sm:text-2xl">
                <div className="flex justify-center items-center font-bold absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-Headline text-nowrap">
                  <span className="text-[0.55em]">〇〇〇</span>
                  <h3 className="px-1">人才資源</h3>
                  <span className="text-[0.55em]">〇〇〇</span>
                </div>

                <div className="flex flex-col sm:flex-row justify-center gpa-12 py-8">
                  <div className="px-4 py-4 sm:px-12 sm:py-16 flex justify-center md:gap-10 text-center text-[0.9em]">
                    <DisclosureButton>

                      <button className="roundedAnimationBtn bg-secondary text-white  flex-1">
                        <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                          <img
                            src="/images/info.svg"
                            alt=""
                            className="w-32 h-full object-contain object-center"
                          />
                        </div>
                        <div className="grow ">高雄市人才資源</div>
                      </button>
                    </DisclosureButton>
                  </div>

                  <div className="px-4 py-4 sm:px-12 sm:py-16 flex justify-center md:gap-10 text-center text-[0.9em]">
                    <a
                      href="https://adl.edu.tw/lecturer.php"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=""
                    >
                      <button className="roundedAnimationBtn bg-primary text-white  flex-1">
                        <div className="p-2 sm:p-4 bg-white w-1/4 h-full">
                          <img
                            src="/images/fix.svg"
                            alt=""
                            className="w-32 h-full object-contain object-center"
                          />
                        </div>
                        <div className="grow ">教育部人才資源</div>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DisclosurePanel>
            <div className="staticSection !pt-0">
              <div className="sectionContent">
                <div id="news" className='text-lg lg:text-3xl w-fit border-b-4 border-primary font-medium mt-6 mb-8 lg:mb-12 p-1 lg:p-3 mx-auto'>高雄市人才資源</div>
                <div className="padlet-embed" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', boxSizing: 'border-box', overflow: 'hidden', position: 'relative', width: '100%', background: '#F4F4F4' }}>
                  <p style={{ padding: '0', margin: '0' }}>
                    <iframe src="https://affairs.kh.edu.tw/6856/upload/upload_list/87" title="高雄市人才資源內容" allow="camera;microphone;geolocation" style={{ width: '100%', height: '70vh', display: 'block', padding: '0', margin: '0' }}></iframe>
                  </p>
                </div>
              </div>
            </div>
          </DisclosurePanel>
        </Disclosure>
      </div>
    </div>
  );
};
